<script setup lang="ts">
import type { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

import { TUTOR_KANBAN_STAGE_COLOR } from '../config/tutor-kanban-stage-color.const'

defineOptions({
  name: 'TutorKanbanStage',
})

defineProps<{
  stage: TutorKanbanStage
}>()
</script>

<template>
  <div
    :class="['tkb-stage', TUTOR_KANBAN_STAGE_COLOR[stage]]"
  >
    <div
      v-if="$slots.head"
      class="tkb-stage__head"
    >
      <slot name="head" />
    </div>
    <div
      v-if="$slots.default"
      class="tkb-stage__body"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanStage.scss" />
